import * as React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import SwitchGoal from "pages/auth/switchgoal/SwitchGoal";

export default function SwicthGoalDialog({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
        <Box sx={{ minHeight: "53vh" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              p: 2,
            }}
          >
            <Box onClick={handleClose} sx={{ cursor: "pointer" }}>
              <CloseIcon />
            </Box>
          </Box>

          <DialogContent>
            <Box
              noValidate
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                m: "auto",
                width: "fit-content",
              }}
            >
              <SwitchGoal setOpen={setOpen} />
            </Box>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
}
